
export default function AboutMission() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Our Mission & Vision
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-2xl font-semibold text-blue-600 mb-3">Mission</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  To democratize access to world-class business resources, mentorship, and opportunities by creating a global ecosystem where entrepreneurs, startups, and established companies can connect, collaborate, and thrive together.
                </p>
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-blue-600 mb-3">Vision</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  To become the world's leading platform for business transformation, where every company—regardless of size or stage—has access to the tools, networks, and expertise needed to achieve sustainable growth and global impact.
                </p>
              </div>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/4fc9c08cd38adcad4164866ac3bf22d1.jpg"
              alt="Mission and Vision"
              className="rounded-lg shadow-lg object-cover w-full h-96"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
